import React, { useEffect, useState } from 'react';
import {  useLocation, useNavigate } from 'react-router-dom';



const BackButton = () => {
  const nav = useNavigate()
  const [product, setProduct] = useState(""); // Declare product as state
  const location=useLocation()
  useEffect(() => {
    const variable = location.pathname;
    if (variable === "/") {
      setProduct(""); // Set a value for product
    } else if (variable === "/About") {
      setProduct("/ABOUT  ");
    }else if (variable === "/Products") {
      setProduct("/PRODUCTS ");
    }else if (variable === "/Projects") {
      setProduct("/PROJECTS");
    }else if (variable === "/Projectdetails") {
      setProduct("/PROJECTS");}
  }, []); 
  const handleBackClick = () => {
    nav(-1);
  };

  return (
    <h1 className="back-button" onClick={handleBackClick}>
      {product}
    </h1>
  );
};

export default BackButton;